/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waist (cm)`)
};

const es_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura (cm)`)
};

const de_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (cm)`)
};

const nl_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (cm)`)
};

const fr_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (cm)`)
};

const it_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vita (cm)`)
};

const pt_br2_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura (cm)`)
};

const pt_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura (cm)`)
};

const ja_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`腰周り (cm)`)
};

const zh_bf_waist = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`腰围（厘米）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_waist = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_waist(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_waist", locale)
	if (locale === "en") return en_bf_waist(inputs)
	if (locale === "es") return es_bf_waist(inputs)
	if (locale === "de") return de_bf_waist(inputs)
	if (locale === "nl") return nl_bf_waist(inputs)
	if (locale === "fr") return fr_bf_waist(inputs)
	if (locale === "it") return it_bf_waist(inputs)
	if (locale === "pt-BR") return pt_br2_bf_waist(inputs)
	if (locale === "pt") return pt_bf_waist(inputs)
	if (locale === "ja") return ja_bf_waist(inputs)
	return zh_bf_waist(inputs)
};